module.exports = __webpack_public_path__ + "img/logo3.ad2a140a.svg";